const defaultState = {
  // 线上服务器地址
  // api: "https://appsrv.hitpaw.com/app",
  // ws_api: "wss://appsrv.hitpaw.com/app",
  // 测试服务器地址
  api: "https://hitpaw-test-api.afirstsoft.cn/app",
  ws_api: "wss://hitpaw-test-api.afirstsoft.cn/app",
};

export default function onAction(state = defaultState) {
  return state;
}
